import { Component, OnInit } from '@angular/core';
import { ShoppingCartService } from './shopping-cart.service';
import { environment } from '../../environments/environment';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../_services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {
	environment = environment;
	public shoppingCart : any = [];
	public grandTotal !: number;
	public shipping : number = 0;
	public isLoggedIn$=false;
	public loading:boolean = false;
	constructor(
		public cartService: ShoppingCartService, 
		private titleService: Title,
		private authService:AuthService,
		private toastr:ToastrService,
		private router:Router
		) { }

	ngOnInit(): void {
		this.titleService.setTitle("Shopping Cart")

		this.authService.userData$.subscribe(res=>{
			if(res?.authdata) {
				this.isLoggedIn$ = true;
			} else {
				this.isLoggedIn$ = false;
			}
		})
	}

	placeOrderOnAccount(){
		this.loading=true;
		this.cartService.placeOrderOnAccount().subscribe((res:any)=>{
			this.toastr.success('Your order was placed successfully.');
			this.loading=false;
			this.cartService.cart.empty();
			this.router.navigateByUrl("/orders/"+res.reference_id);

		},(error:any)=>{
			this.toastr.error('Can not place your order. Please try again!');
			this.loading=false;
		});
	}
}
